import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import TranslatedCopy from '../../intl/translated-copy';
import manageTracking from '../../analytics/creators/manage.js';
import { sendAnalytics } from '../../analytics/tracker';
import Loading from './../global/loading-screen';
import Btn from '../global/button';

import {
  userSignUpGetOtp,
  userSignUpSendOtp,
} from '../../../redux/actions/index';

const mapStateToProps = state => {
  return ({
    getOtpError: state.UserProfileSession.getOtpError,
    isOtpValid: state.UserProfileSession.isOtpValid,
    loadingPorfileRequestStart: state.UserProfileSession.loadingPorfileRequestStart,
  });
};

const FormOTP = (props) => {
  const {
    contentFormRegistration,
    dispatch,
    getOtpError,
    handleBackButtonClick,
    handleOtpValidSubmit,
    isModal,
    isOtpValid,
    loadingPorfileRequestStart,
  } = props;

  const inputs = useRef(Array(6).fill(''));
  const [statusCode, setStatusCode] = useState('');
  const [errorCopyId, setErrorCopyId] = useState('');

  useEffect(() => {
    dispatch(sendAnalytics({
      eventCreator: manageTracking.userProfileRegistrationOtp('step 2', 'codigo verificación'),
    }));
  }, []);

  useEffect(() => {
    if (isOtpValid !== undefined) {
      if (!isOtpValid) {
        let errorCopy = '';
        setStatusCode('error');
        if (getOtpError === 'ERR.UB.OTP.OTP_CODE_NOT_FOUND' || getOtpError === 'ERR.UB.OTP.POST.INVALID_REQUEST') {
          errorCopy = 'PRO_HOME2.0_OTP_INCORRECT';
        }
        setErrorCopyId(errorCopy);
      } else {
        setStatusCode('success');
      }
    }
  }, [isOtpValid]);

  const inputsClasses = cx('otp', {
    'otp-success': statusCode === 'success',
    'otp-error': statusCode === 'error',
  });

  const formContainerClasses = cx('form-otp-container', {
    'is-modal': isModal,
    'is-updating': loadingPorfileRequestStart,
  });

  const isInputsFilled = () => {
    return !inputs.current.some((element) => element.value === '');
  };

  const validateAlphaNumeric = (value) => {
    const alphanumericRegex = /^[A-Za-z0-9]+$/;
    return alphanumericRegex.test(value);
  };

  const checkOTPCode = () => {
    let enteredOtp = '';

    inputs.current.map((dataValue) => {
      enteredOtp += dataValue?.value;
    });
    dispatch(userSignUpGetOtp());
    return enteredOtp;
  };

  const handleSubmit = () => {
    const otpCode = checkOTPCode();
    handleOtpValidSubmit(otpCode);
  };

  const handleInputChange = (event, index) => {
    const { value } = event.target;
    inputs.current[index].classList.add('otp-value');

    if (statusCode === 'error' && value.length === 0 ) {
      setStatusCode('');
      setErrorCopyId('');
    }

    if (!validateAlphaNumeric(value) && value.length > 0) {
      event.target.value = '';
      return;
    }

    if (value.length === 0) {
      inputs.current[index].classList.remove('otp-value');
    }

    if (value.length === 0 && index > 0) {
      inputs.current[index - 1].focus();
    } else if (value.length === 1 && index < inputs.current.length - 1) {
      inputs.current[index + 1].focus();
    }

    if (isInputsFilled()) {
      checkOTPCode();
    }
  };

  const handlePaste = (event, index) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData('text');

    if (validateAlphaNumeric(pastedText)) {
      inputs.current[index].value = pastedText.charAt(0);
      let remainingValue = pastedText.slice(1);
      let i = index + 1;
      while (remainingValue.length > 0 && i < inputs.current.length) {
        inputs.current[i].value = remainingValue.charAt(0);
        remainingValue = remainingValue.slice(1);
        inputs.current[i].focus();
        i++;
      }
    }

    if (isInputsFilled()) {
      checkOTPCode();
    }
  };

  const handleResendOtpClick = () => {
    const data = contentFormRegistration ? {
      email: contentFormRegistration.email,
      name: contentFormRegistration.firstName + ' ' + contentFormRegistration.lastName,
    } : {};
    dispatch(userSignUpSendOtp(data));
  };

  return (
    <div className={ formContainerClasses }>
      <button
        className='otp-backButton'
        onClick={ handleBackButtonClick } >
        <span className='Icon Icon--calendarArrowLeft' />
        <TranslatedCopy
          className='copy-backButton'
          copyID='PRO_HOME2.0_RETURN' />
      </button>
      <div>
        <TranslatedCopy
          className='otp-title'
          copyID='PRO_HOME2.0_OTP_TITLE'
          tagName='p' />
        <TranslatedCopy
          className='otp-subtitle'
          copyID='PRO_HOME2.0_OTP_DESCRIPTION'
          tagName='p' />
        <TranslatedCopy
          className='otp-minute'
          copyID='PRO_HOME2.0_OTP_TIME'
          tagName='p' />
      </div>
      <div className='container-inputs-otp'>
        {inputs.current.map((input, index) => (
          <input
            className={ inputsClasses }
            key={ index }
            maxLength={ 1 }
            onChange={ (event) => handleInputChange(event, index) }
            onPaste={ (event) => handlePaste(event, index) }
            ref={ (ref) => (inputs.current[index] = ref) }
            type='text' />
        ))}
      </div>
      <TranslatedCopy
        className='otp-text-error'
        copyID={ errorCopyId }
        tagName='p' />
      <TranslatedCopy
        className='otp-resend'
        copyID='PRO_HOME2.0_OTP_RESEND'
        onClick={ handleResendOtpClick }
        tagName='a' />
      <div className='otp-login-submitBtn'>
        <Btn
          block={ true }
          btnType='submit'
          className='otp-registerbtn'
          copyID='PRO_HOME_LOGIN_OTP_BUTTON'
          disabled={ loadingPorfileRequestStart || !isOtpValid }
          filled={ true }
          onBtnClick={ () => handleSubmit() }
          visuallyDisabled={ loadingPorfileRequestStart || !isOtpValid }
        />
      </div>
      { loadingPorfileRequestStart &&
        <Loading
          isDataLoading={ true }
          seatmap={ true }
          type='airplaneWindow'
        />
      }
    </div>
  );
};

export default connect(mapStateToProps)(FormOTP);
